import { Grid, makeStyles, Theme } from "@material-ui/core";
import { TextField } from "@ofqual/portal-components/components/TextField";
import React from "react";
import { ScopeApplication } from "../../domain/ScopeApplication";
import { SectionProps } from "./SectionProps";
import { Controller } from "react-hook-form";
import { FileInput } from "@ofqual/portal-components/components/FileInput";
import { authSelector, itemSelector } from "../../redux/selectors";
import { ExperimentalFeature } from "@ofqual/portal-components/components/ExperimentalFeature";
import { useDispatch, useSelector } from "react-redux";
import { Error } from "../common/Error";
import { AttachmentList } from "../item/AttachmentList";
import { deleteSelectedAttachment } from "../../redux/actions";
import { Attachment } from "../../domain/Attachment";
import { scopeExpansionService } from "../../services";
import { useParams } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => {
  return {
    formHeading: {
      color: "#9f9f9f",
      fontSize: "1em",
      marginBottom: "30px",
      fontWeight: 600,
      position: "relative",
    },
  };
});

export const QuestionFour: React.FC<SectionProps<ScopeApplication>> = ({
  control,
  errors,
  disabled,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { token, experimentalFeatures } = useSelector(authSelector);
  const { scopes, attachments } = useSelector(itemSelector);



  const epaQualType = 25;
  const questionFourEnabled = scopes.filter(
    (x) => x.qualificationType === epaQualType
  ).length;

  const { itemId, id } = useParams<{
    itemId: string;
    id: string;
  }>();

  const deleteAttachment = (attachment: Attachment) =>
    dispatch(deleteSelectedAttachment(attachment));

  const buildGetBlob = (blobId: string): Promise<Blob> =>
    scopeExpansionService.downloadAttachment(itemId, id, blobId, { token });

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Controller
          control={control}
          name="questionFour"
          as={
            <TextField
              variant="outlined"
              label="Question 4 answer (If applicable)"
              data-test="question-4"
              fullWidth
              multiline
              rows="15"
              readOnly={disabled || !questionFourEnabled}
            />
          }
        />
        {errors.questionFour && errors.questionFour.message && (
          <Error>{errors.questionFour.message}</Error>
        )}
      </Grid>
      <Grid item xs={12}>
      
        <ExperimentalFeature
           experimentalModuleName="portal-organisations-scope"
           experimentalFeatures={experimentalFeatures}
           experimentalFeatureVisibleName="organisation-expansion-question-four-files"        
        >
          <h6
            className={classes.formHeading}
            style={{ marginTop: "8px", marginBottom: "8px" }}
            data-test="attachments-heading"
          >
            Upload Attachments
          </h6>
          <Controller
            defaultValue={null}
            control={control}
            name="questionFourAttachments"
            
            as={
              <FileInput
                disabled={disabled || !questionFourEnabled}
                multiple={true}
              />
            }
          />
        </ExperimentalFeature>
        
        {attachments.length ? (
          <AttachmentList
            canEdit={!disabled}
            attachments={attachments}
            deleteAttachment={deleteAttachment}
            getBlob={buildGetBlob}
          />
        ) : null}
      </Grid>
    </Grid>
  );
};
